import type {
  CalendarEventResponse,
  CalendarResponse,
  CreateCalendarEventRequest,
  CreateCalendarRequest,
  OccurrenceResponse,
  UpdateCalendarEventRequest,
  UpdateCalendarRequest,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export const calendarApi = {
  listCalendars(includeArchived = false, signal?: AbortSignal) {
    return apiRequest<CalendarResponse[]>('/calendar/calendars', {
      query: { includeArchived },
      signal,
    });
  },

  createCalendar(body: CreateCalendarRequest) {
    return apiRequest<CalendarResponse>('/calendar/calendars', { method: 'POST', body });
  },

  updateCalendar(calendarId: string, body: UpdateCalendarRequest) {
    return apiRequest<CalendarResponse>(`/calendar/calendars/${calendarId}`, {
      method: 'PATCH',
      body,
    });
  },

  /** There is no delete. A calendar is archived — see ADR-0006. */
  archiveCalendar(calendarId: string) {
    return apiRequest<CalendarResponse>(`/calendar/calendars/${calendarId}/archive`, {
      method: 'POST',
    });
  },

  getEvent(eventId: string, signal?: AbortSignal) {
    return apiRequest<CalendarEventResponse>(`/calendar/events/${eventId}`, { signal });
  },

  createEvent(body: CreateCalendarEventRequest) {
    return apiRequest<CalendarEventResponse>('/calendar/events', { method: 'POST', body });
  },

  updateEvent(eventId: string, body: UpdateCalendarEventRequest) {
    return apiRequest<CalendarEventResponse>(`/calendar/events/${eventId}`, {
      method: 'PATCH',
      body,
    });
  },

  deleteEvent(eventId: string) {
    return apiRequest<void>(`/calendar/events/${eventId}`, { method: 'DELETE' });
  },

  /** `from`/`to` are `YYYY-MM-DD` — real Calendar entries expanded across
   *  the range, merged with published Events and Group weekly meetings. */
  listOccurrences(from: string, to: string, signal?: AbortSignal) {
    return apiRequest<readonly OccurrenceResponse[]>('/calendar/occurrences', {
      query: { from, to },
      signal,
    });
  },
};
